import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { DialogActions, DialogContent } from "@material-ui/core";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import Dialog from "../../waybee-ui/Dialog/Dialog";
import Button from "../../waybee-ui/Button";

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 8px;
`;

const SuccessIcon = styled(CheckCircleIcon)`
  && {
    color: #2e7d32;
    font-size: 64px;
  }
`;

const Title = styled.h3`
  font-size: 22px;
  font-weight: 500;
  color: #00303b;
  margin: 16px 0 8px;
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #4a4a4a;
  margin: 0;
  line-height: 1.4;
`;

const Actions = styled(DialogActions)`
  justify-content: center;
  padding: 8px 24px 24px;
`;

function ResetSuccessDialog({ open, onClose }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Content>
        <SuccessIcon />
        <Title>{t("login.resetSuccessTitle")}</Title>
        <Message>{t("login.resetSuccess")}</Message>
      </Content>
      <Actions>
        <Button variant="contained" color="primary" onClick={onClose}>
          {t("login.resetSuccessOk")}
        </Button>
      </Actions>
    </Dialog>
  );
}

ResetSuccessDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

ResetSuccessDialog.defaultProps = {
  open: false
};

export default ResetSuccessDialog;
